export default {"src":"/_next/static/media/ArbitrumLogo.db93275c.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};